import HeaderMounter from '../Components/SharedComponents/Header/HeaderMounter';
import FooterMounter from '../Components/SharedComponents/Footer/FooterMounter';
import { getBaseUdirNoURL } from './searchHelpers';
import Logo from '../svg/udirlogo';
import LogoPride from '../svg/udirlogoPride';
import { shouldShowPrideLogo } from './generalHelpers';
import ReactDOM from 'react-dom/client';
import React from 'react';
import { LogWarning, Log } from '../utils/logging';

export enum SearchSite {
    LPV,
    FoR,
    Eksamensoppgaver,
    Regelverk,
    Global
}

async function setupHeaderAndFooter(searchSite: SearchSite) {
    // Checking if header/footer is cached
    let headerDataCached = sessionStorage.getItem('headerData');
    let footerDataCached = sessionStorage.getItem('footerData');
    let headerData; let footerData; let lowerKeysFooterData;
    
    if(headerDataCached && footerDataCached){
        Log("Using Cached Header and Footer");
        headerData = JSON.parse(headerDataCached || '{}');
        headerData = mapObjectHrefs(headerData);
        footerData = JSON.parse(footerDataCached || '{}');
        footerData = mapObjectHrefsFooter(footerData);
        lowerKeysFooterData = createCamelCaseKeys(footerData);
        HeaderMounter(searchSite, headerData);
        setTimeout(() => logoRenderer(), 100);
        FooterMounter(undefined, lowerKeysFooterData);
        return;
    }

    const footerRoot = ReactDOM.createRoot(document.getElementById('footer') as HTMLElement);
    try {
        Log("Getting header and footer from REST");
        const menuDataURL = getMenuDataURL();
        const menuData = await fetch(menuDataURL);
        const jsonMenuData = await menuData.json();        
        headerData = jsonMenuData['header'];
        headerData = mapObjectHrefs(headerData);

        footerData = jsonMenuData['footer'];
        footerData = mapObjectHrefsFooter(footerData);
        lowerKeysFooterData = createCamelCaseKeys(footerData);
        
        HeaderMounter(searchSite, headerData);
        // Wait for header to be rendered before applying logo modifications
        setTimeout(() => logoRenderer(), 100);
        FooterMounter(footerRoot, lowerKeysFooterData);
        
        sessionStorage.setItem('headerData', JSON.stringify(headerData));
        sessionStorage.setItem('footerData', JSON.stringify(footerData));
    } catch(e) {
        LogWarning("Failed to load dynamic footer data, using fallback");
        HeaderMounter(searchSite);
        setTimeout(() => logoRenderer(), 100);
        FooterMounter(footerRoot);
    }
}

function getMenuDataURL(){
    let apiUrl = "";
    if(window.location.hostname === 'localhost'){
        apiUrl = "https://testdesk.udir.no/api/data/lk20menu";
    } else if(window.location.hostname === 'dev-sokeresultat.udir.no' || window.location.hostname === "udir-sok-utv.azurewebsites.net"){
        apiUrl = "https://testdesk.udir.no/api/data/lk20menu";
    } else if(window.location.hostname === 'qa-sokeresultat.udir.no' || window.location.hostname === "udir-sok-test.azurewebsites.net"){
        apiUrl = "https://qa.udir.no/api/data/lk20menu";
    } else {
        apiUrl = "https://www.udir.no/api/data/lk20menu";
    }
    return apiUrl;
}

function logoRenderer(){
    let logoNode = document.getElementsByClassName("uds-logo")[0] as HTMLElement;
    
    // Check if logoNode exists before trying to access its properties
    if (!logoNode) {
        LogWarning("Logo node not found, header may not be rendered yet");
        return;
    }
    
    logoNode.style.backgroundImage = "none";
    logoNode.style.width = "176px";
    logoNode.style.height = "53px";
    
    let logoImage = document.getElementsByClassName("header__print-logo")[0] as HTMLElement;
    if(logoImage && logoImage !== null){
        logoImage.setAttribute("alt","Utdanningsdirektoratet");
    }

    let logo = React.createElement(shouldShowPrideLogo() ? LogoPride : Logo);
    const logoNodeRoot = ReactDOM.createRoot(logoNode);
    logoNodeRoot.render(logo);
}

function mapObjectHrefsFooter(object: any){
    const baseUrl = getBaseUdirNoURL();
    
    let stringObject = JSON.stringify(object);
    const regexp = /("href":"\/)/g;
    const replaceStringObject = stringObject.replace(regexp, `"href":"${baseUrl}/`);
    return JSON.parse(replaceStringObject);
}

function mapObjectHrefs(object: any) {
    const baseUrl = getBaseUdirNoURL();
    
    object["linkToHomeUrl"] = baseUrl;
    let stringObject = JSON.stringify(object);
    const regexp = /("href":"\/)/g;
    const replaceStringObject = stringObject.replace(regexp, `"href":"${baseUrl}/`);
    return JSON.parse(replaceStringObject);
}

function createCamelCaseKeys(data: any) {
    let lowerData = {};
    if(data && typeof(data) !== 'object') {
        return data;
    }
    if (Array.isArray(data)) {
        return data.map(dataObject => {
            return createCamelCaseKeys(dataObject);
        });
    }
    else {
        Object.keys(data).forEach(key => {
            if (key) {
                const camelCase = key[0].toLowerCase() + key.slice(1);
                if (data[key] && typeof (data[key]) === "object") {
                    lowerData[camelCase] = createCamelCaseKeys(data[key])
                } else {
                    lowerData[camelCase] = data[key];
                }
            }
        });
        return lowerData;
    }
}


export default setupHeaderAndFooter;
